import { create } from "zustand";
import { devtools } from "zustand/middleware";

import LOCALES, { type Locale } from "./locales";
import { getLocaleFromStorage, saveLocaleToStorage } from "./localeStorage";

/**
 * The app's current language.
 *
 * This must be a single store shared by every app in the bundle: the customer
 * portal's profile settings writes the selection, and oem's LanguageProvider
 * reads it to pick the message bundle for its IntlProvider. Two instances
 * would mean changing the language in the portal had no effect.
 */

function loadLanguageFromLocalStorage(): Locale {
  let lang = getLocaleFromStorage();
  if (!lang) {
    saveLocaleToStorage(LOCALES[0]);
    lang = LOCALES[0];
  }
  return lang;
}

type LanguageState = {
  lang: Locale;
  setLang: (lang: Locale) => void;
};

export const useLanguageStore = create<LanguageState>()(
  devtools(
    (set) => ({
      lang: loadLanguageFromLocalStorage(),
      setLang: (lang) => set({ lang }),
    }),
    { name: "LanguageStore" },
  ),
);
